import { EmarsysAction, EmarsysStateType } from '@/data/context/actions/emarsys';
import { emarsysReducer, initialEmarsyState } from '@/data/context/reducers/emarsys';
import { createContext, ReactNode, useContext, useReducer } from 'react';

type EmarsysContextType = {
	state: EmarsysStateType;
	dispatch: React.Dispatch<EmarsysAction>;
};

export const EmarsysContext = createContext<EmarsysContextType>({} as EmarsysContextType);

export const EmarsysProvider = ({ children }: { children: ReactNode }) => {
	const [state, dispatch] = useReducer(emarsysReducer, initialEmarsyState);

	return <EmarsysContext.Provider value={{ state, dispatch }}>{children}</EmarsysContext.Provider>;
};

export const useEmarsys = () => {
	const context = useContext(EmarsysContext);
	if (!context) throw new Error('useEmarsys must be used within an EmarsysProvider');
	return context;
};
